import { memo } from 'react'
import { useHistory, useLocation, useRouteMatch } from 'react-router-dom'

import useExtractSearchDetails from 'components/globalSearch/useExtractSearchDetails'
import config from 'config'
import { CopilotLegalTerms } from 'types/CopilotLegalTerms'
import ModuleFederationLoader from 'utils/ModuleFederationLoader'

interface CopilotProps {
  isPin: boolean
  onPin: (isPinned: boolean) => void
  copilotLegalTerms: CopilotLegalTerms
}

const Copilot = ({ isPin, onPin, copilotLegalTerms, ...props }: CopilotProps): JSX.Element => {
  const history = useHistory()
  const location = useLocation()
  const { url } = useRouteMatch()
  const { globalKeywords } = useExtractSearchDetails({ integrateSupportLinks: false })

  return (
    <ModuleFederationLoader
      module="copilotUi"
      subAppModuleFederation={config.subAppsModuleFederation.uccCopilot}
      initSentry={false}
      nagivateTo={history.push}
      globalKeywords={globalKeywords}
      activePath={location.pathname.replace(`${url}/`, '')}
      isPin={isPin}
      onPin={onPin}
      copilotLegalTerms={copilotLegalTerms}
      {...props}
    />
  )
}

export default memo(Copilot)
